import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle, AlertCircle, Info, Loader2 } from 'lucide-react';
import type { Toast as ToastType } from '../../hooks/useToast';
import styles from './Toast.module.css';

interface ToastProps {
  toasts: ToastType[];
  onRemove: (id: string) => void;
}

const icons = {
  success: CheckCircle,
  error: AlertCircle,
  info: Info,
  progress: Loader2,
};

export function ToastContainer({ toasts, onRemove }: ToastProps) {
  return (
    <div className={styles.container}>
      <AnimatePresence>
        {toasts.map((toast) => {
          const Icon = icons[toast.type];
          const isProgress = toast.type === 'progress';

          return (
            <motion.div
              key={toast.id}
              className={`${styles.toast} ${styles[toast.type]}`}
              initial={{ opacity: 0, y: 50, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.9 }}
              transition={{ duration: 0.2 }}
            >
              <Icon size={18} className={`${styles.icon} ${isProgress ? styles.spinner : ''}`} />
              <div className={styles.content}>
                <span className={styles.message}>{toast.message}</span>
                {isProgress && toast.progress !== undefined && (
                  <div className={styles.progressBar}>
                    <div
                      className={styles.progressFill}
                      style={{ width: `${toast.progress}%` }}
                    />
                  </div>
                )}
              </div>
              {!isProgress && (
                <button
                  className={styles.closeBtn}
                  onClick={() => onRemove(toast.id)}
                >
                  <X size={14} />
                </button>
              )}
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
